<template>
<div v-if="utmSource === 'Hearst'">
    <div v-if="showLogo" class="hearst-logo hide-logo">
        <div class="partner-logo">
            <img :src="hearstLogoUrl" :alt="imgAlt">
        </div>
        <div class="separator">
            <div class="pipe"></div>
        </div>
        <div class="welcome">
            <div class="welcome-text">Welcome to</div>
            <div class="mvt-logo"></div>
        </div>
    </div>
     <img src="https://ib.adnxs.com/getuid?https://api.permutive.com/v2.0/px/track?k=8cbbdd6e-f6b9-4f84-9637-a93d3032cbf2&i=$UID&e=Pageview&p=%257B%2522client%2522%253A%257B%2522domain%2522%253A%2522Movoto%2522%257D%257D&it=appnexus&rand=115563" height="1" width="1" border="0" />
</div>
</template>

<script src="./hearst-logo.js">
</script>
<style lang="scss">
@use "./hearst-logo.scss" as *;
</style>
